import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FichaMedicaAvancesService } from '../../../../services/ficha-medica-avances.service';
import { ErroresService } from '../../../../core/services/errores.service';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { FichaMedicaAvances } from '../../../../models/fichaMedicaAvances';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ficha-medica-avances-editar-dialog',
  templateUrl: './ficha-medica-avances-editar-dialog.component.html',
  styleUrls: ['./ficha-medica-avances-editar-dialog.component.css']
})
export class FichaMedicaAvancesEditarDialogComponent implements OnInit {

  @Input() feriadoId;
  @Input() disabledEditing: boolean;
  
  MensajeError: string = '';
  fichaInvalida: boolean;
  guardando: boolean;
  DatosValidos: boolean;
  EsEdicion: boolean = false;
  registerForm: FormGroup;
  submitted = false;
  controlType: number;
  permisoEdicion: boolean = false;

  constructor(public dialogRef: MatDialogRef<any>, 
              @Inject(MAT_DIALOG_DATA) public data: any, 
              private avancesService: FichaMedicaAvancesService, 
              private dialog: MatDialog, 
              private fb: FormBuilder, 
              private erroresService: ErroresService,
              private momentService: MomentSetService)
  {
  }

  ngOnInit(): void
  {
    this.configurarValidadores();

    this.registerForm.patchValue(this.data.param);
    if (this.data.param.id != 0)
    {
      this.registerForm.get('fecha').patchValue(new Date(this.registerForm.value.fecha));
    }
    
    this.permisoEdicion = this.data.permisoEdicion;
    if (!this.permisoEdicion) this.deshabilitarForm();
  }

  configurarValidadores(): void
  {
    this.registerForm = this.fb.group({
      id: ['', Validators.required],
      fichaMedica: ['', Validators.required],
      fecha: [new Date(), Validators.required],
      avance: ['', Validators.required]
    });
  }

  get registerFormControl()
  {
    return this.registerForm.controls;
  }

  onSubmit(): void
  {
    this.submitted = true;
    if (this.registerForm.valid)
    {
      this.guardando = true;
      
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";
      
      let avance: FichaMedicaAvances = {
        id: this.registerForm.value.id,
        fichaMedica: this.registerForm.value.fichaMedica,
        fecha: this.momentService.saveDateServer(this.registerForm.value.fecha, false),
        avance: this.registerForm.value.avance
      };
      
      this.avancesService.save(avance)
        .subscribe(data =>
        {
          setTimeout(function ()
          {
            this.guardando = false;
            dialogProcesandoRef.close();
          });

          this.dialogRef.close(data);

        },
          error =>
          {
            this.guardando = false;
            dialogProcesandoRef.close();
            
            if (error.status == 400)
            {
              this.fichaInvalida = true;
              
              this.MensajeError = this.erroresService.MostrarError400(error);
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
            }
          });
    }
  }

  cancelar(): void
  {
    this.dialogRef.close(null);
  }

  deshabilitarForm()
  {
    if (this.registerForm != undefined)
    {
      this.registerForm.disable();
    }
  }
}
